import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useApi } from 'model/Api';
import { WorkProcess } from 'model/WorkProcess';
import { generalStyle } from 'helper/Style';
import Layout from 'component/part/Layout';
import BackLink from 'component/part/BackLink';
import H2 from 'component/part/H2';

const WorkProcessList: React.FC = () => {
  const api = useApi();
  const [workProcesses, setWorkProcesses] = useState<WorkProcess[]>([]);

  useEffect(() => {
    (async () => {
      const workProcessesResponse = await api.workProcess.getsByOwn();
      setWorkProcesses(workProcessesResponse);
    })();
  }, []);

  return <Layout>
    <BackLink link='/' label='トップ'></BackLink>
    <H2>作業内容一覧</H2>
    <div css={generalStyle.form}>
      {workProcesses.map((workProcess, index) => (
        <div css={generalStyle.item} key={index}>{workProcess.name}</div>
      ))}
      <div css={generalStyle.formRow}>
        <NavLink to='/work-process/edit' css={generalStyle.button()}>編集</NavLink>
      </div>
    </div>
  </Layout>;
};

export default WorkProcessList;
